import React from 'react';
import { motion } from 'framer-motion';
import DataTable from './DataTable';
import ActivityFeed from './ActivityFeed';
import ProgressChart from './ProgressChart';
import DashboardHeader from './DashboardHeader';

const Dashboard: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <motion.div 
      className="glassmorphic rounded-2xl overflow-hidden border border-white/10 shadow-glass w-full max-w-[700px] mx-auto"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
    >
      <DashboardHeader />
      
      <motion.div className="p-4 grid grid-cols-1 md:grid-cols-2 gap-4" variants={containerVariants}>
        <motion.div variants={itemVariants}>
          <ProgressChart />
        </motion.div>
        
        <motion.div variants={itemVariants}>
          <ActivityFeed />
        </motion.div>
        
        <motion.div className="md:col-span-2" variants={itemVariants}>
          <DataTable />
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default Dashboard;